import { render, staticRenderFns } from "./geographyChart.vue?vue&type=template&id=5d63b676&scoped=true"
import script from "./geographyChart.vue?vue&type=script&lang=js"
export * from "./geographyChart.vue?vue&type=script&lang=js"
import style0 from "./geographyChart.vue?vue&type=style&index=0&id=5d63b676&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d63b676",
  null
  
)

export default component.exports